// Time-of-day greetings shown above the employee name on the home screen.
// Swiss German style: ss only, never ß. Every entry must read naturally as a
// salutation followed by the name on the next line (e.g. "Moin, Luca").

const NIGHT = ["Hallo", "Hi", "Servus"];
const MORNING = ["Guten Morgen", "Moin", "Moinmoin", "Morgähn"];
const MIDDAY = ["Mahlzeit", "Guten Tag", "Hallo"];
const AFTERNOON = ["Guten Nachmittag", "Hallo", "Servus"];
const EVENING = ["Guten Abend", "N'Abend", "Hoi"];
const LATE = ["Hallo", "Hi"];

const FUN = ["Hallihallo", "Heyho", "Grüezi", "Salü", "Hopp"];

export function pickGreeting(now: Date = new Date()): string {
  const h = now.getHours();
  if (Math.random() < 0.2) return FUN[Math.floor(Math.random() * FUN.length)];
  const pool =
    h < 5 ? NIGHT :
    h < 11 ? MORNING :
    h < 14 ? MIDDAY :
    h < 18 ? AFTERNOON :
    h < 22 ? EVENING :
    LATE;
  return pool[Math.floor(Math.random() * pool.length)];
}
